import React from 'react';
import ModalSelector from 'components/ModalSelector';
import TopBanner from 'shared/TopBanner';

function Layout({ children }) {
  return (
    <>
      <div className="page-wrapper ad-padding">
        <TopBanner />
        {children}
      </div>
      <ModalSelector />
    </>
  );
}

export default Layout;
